require('../../modules/es6.string.iterator');
require('../../modules/web.dom.iterable');
module.exports = require('../../modules/_wks-ext').f('iterator');



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/core-js/library/fn/symbol/iterator.js
// module id = 1154
// module chunks = 168707334958949